import Couteau_communication from './images/Couteua-communication.png'
import OutilsCommunication from './Outils-communication'

export default function couteau_communication() {
    const SolutionCommunication = (
        <>
            <div className='content-solution'>
                <div className='solution-titre'>COMMUNICATION</div>
                <div className='solution-img-container'><img className='image-solution' src={Couteau_communication} /></div>
            </div>
            <div className='outil-1'>
                <div className='solution-body-communication'>
                    <OutilsCommunication />
                </div>
            </div>
        </>
    );
    return SolutionCommunication
}